export const PUT = 'PUT'
export const POST = 'POST'
export const GET = 'GET'
export const DELETE = 'DELETE'
export const OPTIONS = 'OPTIONS'
export const PATCH = 'PATCH'

/* HTTP XHR */
export const CREDENTIALS_INCLUDE = 'include'
